import { axios } from '../../services/axios';

export const fetchTags = (type) => axios.get('/tags', { params: { type: type } });
